(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-copos-personalizados"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.nc-landing');
    if (!root) return;
    const params = new URLSearchParams(window.location.search);
    const tracked = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','gbraid','wbraid'];
    tracked.forEach((key) => {
      const incoming = params.get(key);
      if (incoming) sessionStorage.setItem(`nc_${key}`, incoming);
      const field = root.querySelector(`[data-nc-param="${key}"]`);
      if (field) field.value = incoming || sessionStorage.getItem(`nc_${key}`) || '';
    });
    window.dataLayer = window.dataLayer || [];
    const form = root.querySelector('#NcQuoteForm');
    if (form) {
      let started = false;
      form.addEventListener('input', () => {
        if (started) return;
        started = true;
        window.dataLayer.push({ event: 'nc_quote_form_started', form_name: 'copos_personalizados' });
      }, { passive: true });
      form.addEventListener('submit', () => {
        const token = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem('nc_quote_pending', JSON.stringify({ token, created_at: Date.now() }));
      });
    }
    if (root.querySelector('[data-nc-form-success]')) {
      const pendingRaw = sessionStorage.getItem('nc_quote_pending');
      let pending = null;
      try {
        pending = pendingRaw ? JSON.parse(pendingRaw) : null;
      } catch (_error) {
        sessionStorage.removeItem('nc_quote_pending');
      }
      const isRecentSubmission = pending?.token && (Date.now() - Number(pending.created_at) < 30 * 60 * 1000);
      const wasSent = pending?.token && sessionStorage.getItem('nc_quote_conversion_sent') === pending.token;
      if (isRecentSubmission && !wasSent) {
        sessionStorage.setItem('nc_quote_conversion_sent', pending.token);
        sessionStorage.removeItem('nc_quote_pending');
        window.dataLayer.push({ event: 'nc_quote_form_submitted', form_name: 'copos_personalizados' });
        window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };
        window.gtag('event', 'conversion', {
          send_to: 'AW-10816760710/4Fj4CL3qq9AcEIbX6qUo',
          value: 1.0,
          currency: 'BRL'
        });
      }
    }
    root.querySelectorAll('.js-nc-whatsapp').forEach((link) => link.addEventListener('click', () => {
      window.dataLayer.push({ event: 'nc_whatsapp_clicked', page_type: 'landing_copos_personalizados' });
    }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  jQuery(document).ready(function($) {
    $('.btn-close').on('click', function() {
      $(this).parents('.parent-close').slideUp();
    })
  });

  } catch(e) { console.error(e); }
})();
})();
